import {programmedVisibility, initCountdownIfExists} from './modules/announcement-bar';
import ready from 'document-ready';
import nav from './modules/nav';
import windowOnScroll from './modules/windowOnScroll';
import slimSelectInit from './modules/investigation-slim-select';
import gravityforms from './modules/gravityforms';
import {handleSuggestCountryURLBanner} from './modules/suggestCountryURLHandler';

window.lang = document.getElementsByTagName('html')[0].getAttribute('lang') || 'en-US';
window.slimSelectInit = slimSelectInit;
window.documentReady = ready;

// Temporary fix, https://app.asana.com/1/45627463798140/project/582712456631681/task/1209579625562542
window.beforeDearFlipInit = function() {
  window.DEARFLIP.defaults.disableFontFace = window.DEARFLIP.utils.isMac;
};

ready(nav);
ready(windowOnScroll);
ready(programmedVisibility);
ready(initCountdownIfExists);
ready(handleSuggestCountryURLBanner);
ready(gravityforms);
